// extracted by mini-css-extract-plugin
export var closed = "search-styles-module--closed--4725a";
export var genericContainer = "search-styles-module--genericContainer--2c6a4";
export var highlightedText = "search-styles-module--highlightedText--5719a";
export var hitCount = "search-styles-module--hitCount--e60e3";
export var hits = "search-styles-module--hits--adb5e";
export var indexTitle = "search-styles-module--indexTitle--1263f";
export var leftSide = "search-styles-module--leftSide--90051";
export var open = "search-styles-module--open--30f5d";
export var popularTopicItem = "search-styles-module--popularTopicItem--2f79b";
export var popularTopicTitle = "search-styles-module--popularTopicTitle--54632";
export var popularTopics = "search-styles-module--popularTopics--1ccfe";
export var resultContainer = "search-styles-module--resultContainer--3a71d";
export var resultDescription = "search-styles-module--resultDescription--a29c2";
export var resultImg = "search-styles-module--resultImg--80cb2";
export var resultText = "search-styles-module--resultText--b07b6";
export var resultTitle = "search-styles-module--resultTitle--5da0d";
export var rightSide = "search-styles-module--rightSide--281b5";
export var searchBox = "search-styles-module--searchBox--f8849";
export var searchBoxWrapper = "search-styles-module--searchBoxWrapper--6393d";
export var searchContainer = "search-styles-module--searchContainer--e5eb5";
export var searchIcon = "search-styles-module--searchIcon--08312";
export var searchInput = "search-styles-module--searchInput--cea99";
export var searchResult = "search-styles-module--searchResult--dcda3";
export var searchRoot = "search-styles-module--searchRoot--e83c8";
export var show = "search-styles-module--show--7f849";
export var topicsContainer = "search-styles-module--topicsContainer--7c6d9";